var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "app--main"
  }, [_c('section', {
    staticClass: "sub-visual"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap mb-24 mb-md-50 mb-lg-0"
  }, [_c('v-img', {
    staticClass: "tit-wrap__img",
    attrs: {
      "src": "/images/common/tit-img.png"
    }
  }), _c('h2', {
    staticClass: "tit tit--xl"
  }, [_vm._v(" Business ")])], 1)]), _c('v-img', {
    staticClass: "sub-visual__img",
    attrs: {
      "src": "/images/sub/business/sub-visual-business.jpg"
    }
  }), _c('sub-tab', {
    attrs: {
      "page": "비즈니스",
      "tabActive": 3
    }
  })], 1), _c('section', {
    staticClass: "sub-section sub-section--process"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap tit-wrap--center"
  }, [_c('h3', {
    staticClass: "tit tit--lg"
  }, [_vm._v(" 모두에프엔티의 고객맞춤형 물류프로세스는 아래와 같습니다. ")])]), _c('v-img', {
    staticClass: "d-md-none",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100",
      "src": "/images/sub/business/process/osd-mobile.jpg"
    }
  }), _c('v-img', {
    staticClass: "d-none d-md-block",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100",
      "src": "/images/sub/business/process/osd.png"
    }
  })], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }